import {cloneDeep} from "lodash-es";

const NS = 'DateLessThan'; // jshint ignore:line

export default function DateLessThan($timeout) { // as dateLessThan
  "ngInject";

  return {
    require: 'ngModel',
    link,
    restrict: 'A'
  };

  function link(scope, element, attrs, ngModel) {

    var validate = function (viewValue) {
      var dateLessThanStr = attrs.dateLessThan.replace('"', '').replace('"', '');
      var dateLessThan = new Date(dateLessThanStr);
      var lessThanAllowEqual = Boolean(attrs.lessThanAllowEqual);
      if (!ngModel.$modelValue || !ngModel.$viewValue || !dateLessThan || !(dateLessThan instanceof Date) || dateLessThan.toString() === 'Invalid Date') {
        // It's valid because we have nothing to compare against
        ngModel.$setValidity('date-less-than', true);
      } else {
        const modelDate = cloneDeep(ngModel.$modelValue);
        if (ngModel.$viewValue && typeof ngModel.$viewValue === 'string' && ngModel.$viewValue.indexOf(':') !== -1) {
          modelDate.setHours(Number(ngModel.$viewValue.split(':')[0]));
          modelDate.setMinutes(Number(ngModel.$viewValue.split(':')[1]));
        }

        // It's valid if model is lower than the model we're comparing against
        var valid;
        if (lessThanAllowEqual) {
          valid = (modelDate.getTime() <= dateLessThan.getTime()) ? true : false;
        } else {
          valid = (modelDate.getTime() < dateLessThan.getTime()) ? true : false;
        }
        if (!valid) {
          $timeout(function () {
            validate(ngModel.$viewValue);
          }, 500);
        }
        ngModel.$setValidity('date-less-than', valid);
      }
      return viewValue;
    };

    ngModel.$parsers.unshift(validate);
    ngModel.$formatters.push(validate);

    attrs.$observe('dateLessThan', function () {
      // Whenever the comparison model changes we'll re-validate
      return validate(ngModel.$viewValue);
    });
  }
}

